import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DailyProgressCardQueryVariables = Types.Exact<{
  date: Types.Scalars['Date'];
  courierId: Types.Scalars['Int'];
}>;


export type DailyProgressCardQuery = { __typename?: 'Query', DailyProgressByCourierIdAndDate?: { __typename?: 'DailyProgress', totalDeliveries: number, finishedDeliveries: number, cancelledDeliveries: number, finishedPickups: number, r30Retours: number, finishedLockerVisits: number, finishedPudoVisits: number, finishedC2CPickups: number } | null, DeliveriesStatisticsByCourierIdAndDate?: { __typename?: 'DeliveryStatistics', noOfDeliveriesPastEta?: number | null } | null };


export const DailyProgressCardDocument = gql`
    query DailyProgressCard($date: Date!, $courierId: Int!) {
  DailyProgressByCourierIdAndDate(date: $date, courierId: $courierId) {
    totalDeliveries
    finishedDeliveries
    cancelledDeliveries
    finishedPickups
    r30Retours
    finishedLockerVisits
    finishedPudoVisits
    finishedC2CPickups
  }
  DeliveriesStatisticsByCourierIdAndDate(date: $date, courierId: $courierId) {
    noOfDeliveriesPastEta
  }
}
    `;

/**
 * __useDailyProgressCardQuery__
 *
 * To run a query within a React component, call `useDailyProgressCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyProgressCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyProgressCardQuery({
 *   variables: {
 *      date: // value for 'date'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDailyProgressCardQuery(baseOptions: Apollo.QueryHookOptions<DailyProgressCardQuery, DailyProgressCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyProgressCardQuery, DailyProgressCardQueryVariables>(DailyProgressCardDocument, options);
      }
export function useDailyProgressCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyProgressCardQuery, DailyProgressCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyProgressCardQuery, DailyProgressCardQueryVariables>(DailyProgressCardDocument, options);
        }
export type DailyProgressCardQueryHookResult = ReturnType<typeof useDailyProgressCardQuery>;
export type DailyProgressCardLazyQueryHookResult = ReturnType<typeof useDailyProgressCardLazyQuery>;
export type DailyProgressCardQueryResult = Apollo.QueryResult<DailyProgressCardQuery, DailyProgressCardQueryVariables>;